$(document).ready(function () {
       
    $(".bedenIcons div").live("click", function () {
          
        var el = this; 
        var id = $(el).attr("data-type");
          
        $("#ceket").css("display", "none");
        $("#tshirt").css("display", "none");
        $("#pantolon").css("display", "none");
        $("#gomlek").css("display", "none");
        $("#triko").css("display", "none");
        $("#disgiyim").css("display", "none");
        $(".bedenContent  #" + id).css("display", "inherit");
       
    });

});